import { createSlice } from "@reduxjs/toolkit";
import { saveEmployeesMassive, checkEmployeesMassive } from "./async-thunks";
import { ResponseStatusEnum } from "@src/redux/seller-clients";

type dbValue = {
  value: number,
  label: string
}

type validatedEmployee = {
  index: number,
  name: string,
  lastName: string,
  lastName2: string,
  birthDate: string,
  taxData: dbValue,
  sex: string,
  group: dbValue
}

const initialState: { status: ResponseStatusEnum; validatedEmployees: validatedEmployee[] } = {
  status: ResponseStatusEnum.idle,
  validatedEmployees: []
};

export const clientsEmployeesSlice = createSlice({
  name: "clientsEmployees",
  initialState,
  reducers: {
    reset: (state) => {
      state.status = ResponseStatusEnum.idle;
      state.validatedEmployees = [];
    }
  },
  extraReducers: (builder) => {
    builder.addCase(checkEmployeesMassive.fulfilled, (state, action) => {
      state.status = ResponseStatusEnum.success;
      state.validatedEmployees = action.payload;
    });
    builder.addCase(checkEmployeesMassive.pending, (state) => {
      state.status = ResponseStatusEnum.loading;
    });
    builder.addCase(checkEmployeesMassive.rejected, (state) => {
      state.status = ResponseStatusEnum.error;
    });
    builder.addCase(saveEmployeesMassive.fulfilled, (state) => {
      state.validatedEmployees = [];
      state.status = ResponseStatusEnum.success;
    });
    builder.addCase(saveEmployeesMassive.pending, (state) => {
      state.status = ResponseStatusEnum.loading;
    });
    builder.addCase(saveEmployeesMassive.rejected, (state) => {
      state.status = ResponseStatusEnum.error;
    });
  }
});

export const { reset } = clientsEmployeesSlice.actions;
export const clientsEmployeesReducer = clientsEmployeesSlice.reducer;
